import { Injectable, computed, inject } from '@angular/core';
import { AiAssistantStateStore } from './ai-assistant-state.store';

@Injectable({ providedIn: 'root' })
export class AiAssistantFacadeService {
  private readonly stateStore = inject(AiAssistantStateStore);

  readonly isOpen = computed(() => this.stateStore.isOpen());

  open(): void {
    this.stateStore.open();
  }

  close(): void {
    this.stateStore.close();
  }
}
